export enum LegalPersonTypeWithNoOption {
  Employee = "Employee",
  Subcontractor = "Subcontractor",
  NoOption = "NoOption"
}

export function legalPersonTypeToNoOption(v: string | null) {
  if (v === "Employee") {
    return LegalPersonTypeWithNoOption.Employee;
  }

  if (v === "Subcontractor") {
    return LegalPersonTypeWithNoOption.Subcontractor;
  }

  return LegalPersonTypeWithNoOption.NoOption;
}
